// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: white;
  border-radius: 8px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 72px;
  width: 72px;
  margin-bottom: 8px;
}
.error-modal h2 {
  font-family: AppFontBold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.error-modal p::ng-deep {
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
  text-wrap: balance;
  color: #393939;
  margin-bottom: 20px;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/fail-loading-receipt/fail-loading-receipt.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,cAAA;EACA,mBAAA;AAFF;;AAMA;EACC;IACC,2BAAA;IACA,UAAA;EAHA;EAKD;IACC,wBAAA;IACA,UAAA;EAHA;AACF","sourcesContent":[".error-modal {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n\t.error-icon {\n\t\theight: 72px;\n\t\twidth: 72px;\n\t\tmargin-bottom: 8px;\n\t}\n\n\th2 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 12px;\n\t}\n\n\tp::ng-deep {\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t\ttext-wrap: balance;\n\t\tcolor: #393939;\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n@keyframes slideUp {\n\tfrom {\n\t\ttransform: translateY(20px);\n\t\topacity: 0;\n\t}\n\tto {\n\t\ttransform: translateY(0);\n\t\topacity: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
